/**
* BloodTypeController
* @namespace gplans.survey.controllers
*/
(function () {
  'use strict';BloodTypeController.$inject = ["gplansConf", "$http", "$window", "$state", "$localStorage", "$rootScope"];

  angular.
  module('gplans.survey.controllers').
  controller('BloodTypeController', BloodTypeController);

  BloodTypeController.$inject = ['gplansConf', '$http', '$window', '$state', '$localStorage', '$rootScope'];

  /**
                                                                                                             * @namespace BloodTypeController
                                                                                                             */
  function BloodTypeController(gplansConf, $http, $window, $state, $localStorage, $rootScope) {
    var vm = this;
    var data = {
      'male': {
        'dual': {
          'id': 3,
          'name': "Dual Efficient",
          'hdl': {
            'max': 100000,
            'min': 45,
            'inclusive': false },

          'ldl': {
            'max': 160,
            'min': 131,
            'inclusive': true },

          'tc': {
            'max': 260,
            'min': 145,
            'inclusive': true },

          'ratio': {
            'max': 3.0,
            'min': 5.0,
            'inclusive': true },

          'tcrigl': {
            'max': 174,
            'min': 110,
            'inclusive': true } },


        'carb': {
          id: 1,
          name: "Carbohydrate Efficient",
          'hdl': {
            'max': 45,
            'min': -1,
            'inclusive': false },

          'ldl': {
            'max': 100000,
            'min': 160,
            'inclusive': false },

          'tc': {
            'max': 240,
            'min': -1,
            'inclusive': false },

          'ratio': {
            'max': 1000000,
            'min': 3.5,
            'inclusive': false },

          'tcrigl': {
            'max': 110,
            'min': -1,
            'inclusive': false } },


        'fp': {
          id: 2,
          name: "Fat Protein Efficient",
          'hdl': {
            'max': 100000,
            'min': 45,
            'inclusive': false },

          'ldl': {
            'max': 130,
            'min': -1,
            'inclusive': true },

          'tc': {
            'max': 200,
            'min': -1,
            'inclusive': false },

          'ratio': {
            'max': 3.5,
            'min': -1,
            'inclusive': false },

          'tcrigl': {
            'max': 100000,
            'min': 175,
            'inclusive': true } } },



      'female': {
        'dual': {
          'id': 3,
          'name': "Dual Efficient",
          'hdl': {
            'max': 100000,
            'min': 45,
            'inclusive': false },

          'ldl': {
            'max': 160,
            'min': 131,
            'inclusive': true },

          'tc': {
            'max': 260,
            'min': 160,
            'inclusive': true },

          'ratio': {
            'max': 3.5,
            'min': -1,
            'inclusive': false },

          'tcrigl': {
            'max': 174,
            'min': 110,
            'inclusive': true } },


        'carb': {
          id: 1,
          name: "Carbohydrate Efficient",
          'hdl': {
            'max': 40,
            'min': -1,
            'inclusive': false },

          'ldl': {
            'max': 100000,
            'min': 160,
            'inclusive': false },

          'tc': {
            'max': 240,
            'min': -1,
            'inclusive': false },

          'ratio': {
            'max': 1000000,
            'min': 5.0,
            'inclusive': false },

          'tcrigl': {
            'max': 110,
            'min': -1,
            'inclusive': false } },


        'fp': {
          id: 2,
          name: "Fat Protein Efficient",
          'hdl': {
            'max': 100000,
            'min': 55,
            'inclusive': false },

          'ldl': {
            'max': 130,
            'min': -1,
            'inclusive': true },

          'tc': {
            'max': 200,
            'min': -1,
            'inclusive': false },

          'ratio': {
            'max': 4.0,
            'min': -1,
            'inclusive': false },

          'tcrigl': {
            'max': 100000,
            'min': 175,
            'inclusive': true } } } };





    $localStorage['bloodTest'] = true;

    var withinRange = function withinRange(val, min, max, inclusive) {
      if (inclusive) {
        return min <= val && val <= max;
      } else {
        return min < val && val < max;
      }
    };
    vm.gender = $window.gplansStorage.gender;
    vm.data = data;
    var gender = $window.gplansStorage.gender,
    age = $window.gplansStorage.age,
    current_weight = $window.gplansStorage.current_weight,
    goal_weight = $window.gplansStorage.goal_weight;
    vm.formData = {};
    vm.calculate = function () {
      if (!$rootScope.offerId) {
        $window.gplansStorage.gender = vm.gender;
        gender = vm.gender;
      }
      var dataObj = data[gender];
      var metabolicTypes = ['dual', 'carb', 'fp'];
      var measurements = ['hdl', 'ldl', 'tc', 'ratio', 'tcrigl'];
      for (var i = 0; i < metabolicTypes.length; i++) {
        var metabolicType = metabolicTypes[i];
        console.log(metabolicType);
        var goalCount = metabolicType === 'dual' ? 3 : 2;
        var matchCount = 0;
        for (var j = 0; j < measurements.length; j++) {
          var measurement = measurements[j];
          var rangeObj = dataObj[metabolicType][measurement];
          var formValue = vm.formData[measurement];
          var incrementMatches = withinRange(Number(formValue), rangeObj.min, rangeObj.max, rangeObj.inclusive);
          if (incrementMatches) {
            console.log(incrementMatches);
            matchCount++;
          }
          console.log('     ' + measurement);
          if (matchCount === goalCount) {
            console.log('have a winner', matchCount, metabolicType);
            vm.metabolic_type = dataObj[metabolicType];
            $localStorage['bloodTypeResult'] = vm.metabolic_type;
            $state.go('survey.weight_age_form', { surveyId: 1 });
            return;
          }
        }
      }
      // They weren't any other type so make 'em dual.
      metabolicType = 'dual';
      vm.metabolic_type = metabolicType;
      return;
    };

    vm.goBack = function () {
      $window.history.back();
    };

    var fetchMetabolicTypes = function fetchMetabolicTypes() {
      $http.get(gplansConf.API_URL + '/api/v1/metabolictypes/').then(function (res) {
        vm.metabolictypes = res.data;
      });
    };
    fetchMetabolicTypes();
  }
})();